module.exports = __webpack_public_path__ + "img/outgoingrecord.15d786a4.png";